/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */


const theme = {
  appearances: {
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    iconPosition: {
      description: 'Theme styles to be applied to icon links depending on where the icon is in relation to the link text',
      type: 'state',
      values: [ 'left', 'right', 'inline' ]
    },
    inactive: {
      description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
      type: 'state',
      values: [ true ]
    },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    },
    selected: {
      description: 'Applies while an interactive component is the currently selected one in a set of states or components, for example a button in a `ButtonGroup`.',
      type: 'state',
      values: [ true ]
    },
    size: { type: 'variant', values: [ 'small' ] },
    style: {
      description: 'Configure `style` variant for `ButtonGroupItem`',
      type: 'variant',
      values: [ 'contained' ]
    },
    width: {
      description: 'Available in default, responsive or equal. Default-width expands based on content. Responsive automatically applies full-width when is displayed on the XS viewport, equal divide the available width equally among `ButtonGroup`',
      type: 'variant',
      values: [ 'responsive', 'equal' ]
    }
  },
  rules: [
    { if: { width: 'equal' }, tokens: { width: '100%' } },
    {
      if: { size: 'small' },
      tokens: { height: 32, paddingBottom: 4, paddingTop: 4 }
    },
    { if: { focus: true }, tokens: { outerBorderColor: '#000000' } },
    {
      if: { hover: true },
      tokens: {
        backgroundColor: '#404040',
        borderColor: '#404040',
        color: '#ffffff'
      }
    },
    {
      if: { selected: true },
      tokens: { backgroundColor: '#7a3dfc', color: '#ffffff' }
    },
    {
      if: { pressed: true },
      tokens: { backgroundColor: '#404040', color: '#666666' }
    },
    {
      if: { focus: true, selected: true },
      tokens: {
        backgroundColor: '#7a3dfc',
        color: '#ffffff',
        outerBorderColor: '#7a3dfc'
      }
    },
    {
      if: { hover: true, selected: true },
      tokens: { backgroundColor: '#5b2bc2', color: '#ffffff' }
    },
    {
      if: { pressed: true, selected: true },
      tokens: { backgroundColor: '#404040', color: '#666666' }
    },
    {
      if: { inactive: true },
      tokens: { backgroundColor: '#c9c8c8', borderWidth: 0, color: '#ffffff' }
    },
    { if: { iconPosition: 'right' }, tokens: { iconSpace: 1 } },
    { if: { width: 'responsive' }, tokens: { width: '100%' } },
    {
      if: { style: 'contained' },
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0)',
        borderColor: 'rgba(0, 0, 0, 0)',
        borderWidth: 0,
        height: 40,
        paddingBottom: 8,
        paddingTop: 8
      }
    },
    {
      if: { size: 'small', style: 'contained' },
      tokens: { height: 32, paddingBottom: 6, paddingTop: 6 }
    },
    {
      if: { hover: true, style: 'contained' },
      tokens: {
        backgroundColor: '#404040',
        color: '#ffffff',
        outerBorderWidth: 0
      }
    },
    {
      if: { selected: true, style: 'contained' },
      tokens: {
        backgroundColor: '#7a3dfc',
        color: '#ffffff',
        outerBorderWidth: 0
      }
    },
    {
      if: { focus: true, style: 'contained' },
      tokens: { borderColor: '#000000', borderWidth: 1, outerBorderWidth: 0 }
    },
    {
      if: { hover: true, selected: true, style: 'contained' },
      tokens: {
        backgroundColor: '#5b2bc2',
        color: '#ffffff',
        outerBorderWidth: 0
      }
    },
    {
      if: { focus: true, selected: true, style: 'contained' },
      tokens: { outerBorderColor: '#7a3dfc', outerBorderWidth: 1 }
    },
    {
      if: { pressed: true, style: 'contained' },
      tokens: { backgroundColor: '#404040', color: '#666666' }
    }
  ],
  tokens: {
    alignSelf: 'flex-start',
    backgroundColor: '#ffffff',
    borderColor: '#000000',
    borderRadius: 4,
    borderWidth: 1,
    color: '#000000',
    fontName: 'StagSans',
    fontSize: 16,
    fontWeight: '600',
    height: 48,
    iconSize: 20,
    iconSpace: 2,
    lineHeight: 1.5,
    minWidth: 0,
    opacity: 1,
    outerBackgroundColor: 'rgba(0, 0, 0, 0)',
    outerBorderColor: 'rgba(0, 0, 0, 0)',
    outerBorderGap: 3,
    outerBorderWidth: 1,
    paddingBottom: 12,
    paddingLeft: 24,
    paddingRight: 24,
    paddingTop: 12,
    shadow: null,
    textAlign: 'center',
    width: null
  }
}
export default theme
